import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, Row} from "reactstrap";
import modelImageDefault from '../../assets/img/banner/rack.png';
import HorizontalLine from "../Widget/HorizontalLine";
import * as PropTypes from 'prop-types';
import label from 'enqc-utilities/src/label/Label'

import {isEmpty, parseDate} from "../../utils/Utilities";
import MyCardImage from "../Card/MyCardImage";
import ReleaseVerificationFormLaneWidget from "../Widget/ReleaseVerificationFormLaneWidget";
import ReleaseVerificationDetailPage from "../../pages/ReleaseVerificationDetailPage";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import PrimaryCardHeader from "../Widget/PrimaryCardHeader";

export default class ReleaseVerificationDetailModal extends BaseComponent{

    constructor(props){
        super(props);
        let {releaseVerification} = this.props
        if(!releaseVerification){
            releaseVerification = {}
        }
        this.state = {
            releaseVerification:releaseVerification,
            releaseVerificationEvents : [],
            stepNumber : 0
        }
    }

    componentWillReceiveProps(props, nextContext) {
        if(this.props!==props && props.show){
            let {releaseVerification} = props
            if(!releaseVerification){
                releaseVerification = {}
            }
            this.setState({
                releaseVerification:releaseVerification,
                stepNumber : 0
            })
        }
    }

    nextPage = () => {
        let {stepNumber, releaseVerification} = this.state
        let formLaneApplications = releaseVerification.formLaneApplications?releaseVerification.formLaneApplications:[]
        if(stepNumber>=formLaneApplications.length-1){
            return;
        }

        stepNumber = stepNumber+1;

        this.setState({
            stepNumber : stepNumber,
        })
    }

    previousPage = () => {
        let {stepNumber} = this.state
        if(stepNumber<=0){
            return
        }
        stepNumber = stepNumber-1;
        this.setState({
            stepNumber : stepNumber,
        })
    }


    render(){
        let {releaseVerification, viewFocus,  stepNumber} = this.state
        let model = releaseVerification.model??{}
        let modelCategory = model.modelCategory??{}

        let creator = releaseVerification.creator??{}
        let lastPerformer = releaseVerification.user??{}
        let formLaneApplications = releaseVerification.formLaneApplications??[]

        let releaseVerificationStatus = releaseVerification.releaseVerificationStatus??{}
        // let currentReleaseVerificationEvent = releaseVerificationEvents.length>0?releaseVerificationEvents[0]:{}
        // let latestReleaseVerificationEvent = releaseVerificationEvent
        // let currentReleaseVerificationStatus = currentReleaseVerificationEvent.releaseVerificationStatus?currentReleaseVerificationEvent.releaseVerificationStatus:{}
        // let currentReleaseVerificationUser = currentReleaseVerificationEvent.user?currentReleaseVerificationEvent.user:{}
        //
        // let previousReleaseVerificationEvent = releaseVerificationEvents.length>1?releaseVerificationEvents[1]:{}
        // let previousReleaseVerificationStatus = previousReleaseVerificationEvent.releaseVerificationStatus?previousReleaseVerificationEvent.releaseVerificationStatus:{}
        // let previousReleaseVerificationUser = previousReleaseVerificationEvent.user?previousReleaseVerificationEvent.user:{}



        return (
            /*xl-lg-sm*/
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    style={{minWidth:'90%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.show}
                    backdrop={true}>
                    <Card>
                        <PrimaryCardHeader
                            content={(<React.Fragment>
                                <h3>{label.ReleaseVerificationDetail}</h3>
                            </React.Fragment>)}/>
                        <CardBody>
                            <Row>
                                <Col md={3} style={{textAlign:'left'}}>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardBody>
                                                    <div style={{textAlign:'center'}}>
                                                        <MyCardImage
                                                            style={{width:'80%'}}
                                                            src={model.iconPhoto?model.iconPhotoUrl:modelImageDefault}
                                                            onError={(elm)=>this.defaultImage(elm, modelImageDefault)}
                                                        />
                                                    </div>
                                                    <HorizontalLine/>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardBody>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label for="name">{label.Reference}</Label>
                                                                <Input disabled type="text" name="title" value={releaseVerification.reference}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label for="name">{label.Creator}</Label>
                                                                <Input disabled type="text" name="title" value={creator.fullname}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <br/>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label for="name">{label.Created}</Label>
                                                                <Input disabled type="text" name="title" value={parseDate(releaseVerification.created, DD_MMMM_YYYY_HH_MM_SS)}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardBody>
                                                    {
                                                        !isEmpty(lastPerformer)&&(
                                                            <Row>
                                                                <Col>
                                                                    <FormGroup>
                                                                        <Label for="name">{label.LastPerformer}</Label>
                                                                        <Input disabled type="text" name="title" value={lastPerformer.fullname??"-"}/>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        )
                                                    }
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label for="name">{label.Status}</Label>
                                                                <Input
                                                                    className={"inspection-status-"+(releaseVerificationStatus.name?releaseVerificationStatus.name.toLowerCase():"")}
                                                                    disabled type="text" name="title" value={label(releaseVerificationStatus.name)}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label for="name">{label.Updated}</Label>
                                                                <Input disabled type="text" name="title" value={parseDate(releaseVerification.updated, DD_MMMM_YYYY_HH_MM_SS)}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <a href={ReleaseVerificationDetailPage.ENDPOINT+"?id="+releaseVerification.id}>
                                                <Button color={"primary"} block>
                                                    {label.ReleaseVerificationDetail}
                                                </Button>
                                            </a>
                                        </Col>
                                    </Row>
                                    <br/>
                                    {
                                        releaseVerification.canContinue&&(
                                            <>
                                                <Row>
                                                    <Col>
                                                        <Button block onClick={() => {
                                                            this.props.onContinueReleaseVerification(releaseVerification)
                                                        }}>
                                                            {label.Continue}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                                <br/>
                                            </>
                                        )
                                    }
                                    <Row>
                                        <Col>
                                            <Button block color={"danger"} onClick={(e) => {
                                                e.preventDefault()
                                                this.props.onClose()
                                            }}>
                                                {label.Close}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={9}>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <PrimaryCardHeader content={label.Model}/>
                                                <CardBody>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label>{label.SystemType}</Label>
                                                                <Input disabled type="text" name="sistemType" value={model.systemType}/>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label>{label.PartName}</Label>
                                                                <Input disabled type="text" name="partName" value={model.partName}/>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label>{label.PartNumber}</Label>
                                                                <Input disabled type="text" name="partName" value={model.partNumber}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label>{label.ModelName}</Label>
                                                                <Input disabled type="text" name="modelName" value={model.modelName}/>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label>{label.Category}</Label>
                                                                <Input disabled type="text" name="category" value={modelCategory.name}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <FormGroup>
                                                                <Label>{label.Description}</Label>
                                                                <Input disabled type="textarea" name="description" value={model.description}/>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <HorizontalLine/>
                                    <Row>
                                        <Col>
                                            <Button
                                                color={stepNumber==0?"disabled":"warning"}
                                                className={"float-left"}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.previousPage()
                                                }}>
                                                {label.PagePrevious}
                                            </Button>
                                        </Col>
                                        <Col>
                                            <Button
                                                color={stepNumber >= formLaneApplications.length - 1?"disabled":"primary"}
                                                className={"float-right"}
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    this.nextPage()
                                                }}>
                                                {label.PageNext}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <HorizontalLine/>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <ReleaseVerificationFormLaneWidget
                                                releaseVerification={releaseVerification}
                                                stepFormLaneId={formLaneApplications[stepNumber]?formLaneApplications[stepNumber].laneId:0}
                                                formLaneApplication={formLaneApplications[stepNumber]?formLaneApplications[stepNumber]:{}}/>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

ReleaseVerificationDetailModal.propTypes = {
    show:PropTypes.bool.isRequired,
    releaseVerification : PropTypes.object.isRequired,
    onContinueReleaseVerification:PropTypes.func.isRequired,
    onClose:PropTypes.func.isRequired
}
